import React from "react";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow, Typography } from "@mui/material/";
import {
  sortData,
} from "../../common/SortSupport";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { Box } from "@mui/material";
import { AvatarAndName } from "../AvatarAndName";
import { baseUrl } from "../../api/config";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../common/StaticExports";

const ReportsInterviewsTable = (props:any) => {
    const { data } = props;
    const [t] = useTranslation();

  //supporting contents
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Uid");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  let visibleRows = React.useMemo(
    () =>
      data && data.length > 0 && sortData(data, orderBy, order),
    [order, orderBy, data]
  );

  const head = [
    {
      key: "",
      displayName: "id",
    },
    {
      key: "Name",
      displayName: "interview",
    },
    {
      key: "Date",
      displayName: "date",
    },
    {
      key: "DisplayName",
      displayName: "interviewee",
    },
    {
      key: "Role",
      displayName: "role",
    },
  ];

  //table contents
  return (
    <React.Fragment>
      <Box className={'mb20'}>
        <TableContainer>
          <Table stickyHeader size="small" aria-label="a dense table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={head}
            />
            {visibleRows && visibleRows?.length ? (
              <TableBody>
                {visibleRows.map((d: any, i: number) => (
                  <TableRow
                    className="hoverBG"
                    sx={{ cursor: "pointer" }}
                    key={`standards-table-row-${i}`}
                  >
                    <TableCell className="fs12">
                      {i+1}
                    </TableCell>
                    <TableCell className="fs12">
                      {d.Name}
                    </TableCell>
                    <TableCell className="fs12">
                      {formatDate(d.Date)}
                    </TableCell>
                    <TableCell className='fs12'>
                      {
                        d?.Conducted && d?.Conducted?.length > 0 &&
                        d?.Conducted.map((interviewees:any) => {
                          return (
                            <AvatarAndName avatarName={interviewees.DisplayName} avatarImage={interviewees.AvatarPath ? `${baseUrl}/Content${interviewees.AvatarPath}` : ''}/>
                          )
                        })
                      }
                    </TableCell>
                    <TableCell className="fs12">
                      {
                        d?.Conducted && d?.Conducted?.length > 0 &&
                        d?.Conducted.map((interviewees:any) => {
                          return interviewees?.Role ? 
                          <Typography className="fs12">{interviewees?.Role}</Typography> :
                          <Typography className="fs12">{'-'}</Typography>
                        })
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                {/* <TableSkeleton rowCount={8} cellCount={5} /> */}
                <TableRow>
                    <TableCell className="fs12" colSpan={6}>
                      {t('NO_RECORDS_FOUND')}
                    </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </React.Fragment>
  );
};

export default ReportsInterviewsTable;
